import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['input', 'showIcon', 'hideIcon']

  toggle() {
    if (this.inputTarget.type === 'password') {
      this.inputTarget.type = 'text';
      this.toggleClass();
      this.hideIconTarget.focus();
    } else {
      this.inputTarget.type = 'password';
      this.toggleClass();
      this.showIconTarget.focus();
    }
  }

  toggleClass() { // needs to be done before moving the focus
    this.showIconTarget.classList.toggle('d-none');
    this.hideIconTarget.classList.toggle('d-none');
  }
}
